/** @format */
/** @format */

import React, { FC, useState, useMemo, useEffect } from 'react'
import styled from 'styled-components'
import { _$, Drawer } from '@king-design/react'
import QuickRangeDate from 'src/components/QuickRangeDate'
import { DateTimeProps } from 'src/containers/MonitorHistoryTactics/constants'
import { MonitorSearch } from 'src/components'
import useFormTable from 'src/hooks/useFormTable'
import { TablePage } from 'src/components'
import dayjs from 'dayjs'
import Api from 'src/api/ApiCloud'

interface CloudAlarmProps {
  className?: string
  network: 'ib' | 'rock'
  dataSource: string
}
const SeverityGroup = [
  { label: 'Info', value: 'Info' },
  { label: 'Warning', value: 'Warning' },
  { label: 'Minor', value: 'Minor' },
  { label: 'Critical', value: 'Critical' }
]

const CloudAlarm: FC<CloudAlarmProps> = ({ className, network, dataSource }) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [dateTime, setDateTime] = useState<DateTimeProps>({
    StartTime: dayjs().subtract(1, 'hours').unix(),
    EndTime: dayjs().unix()
  })
  const [search, setSearch] = useState<string>('')
  const [tableGroup, setTableGroup] = useState()
  const { run, result, pageState, loading, total } = useFormTable(
    network === 'ib' ? Api.getUFMAlarms : Api.getNCEAlarms,
    {
      params: {
        Query: search,
        DataSource: dataSource,
        ...dateTime
      },
      manual: true
    },
    data => {
      if (network === 'ib') {
        const { AlarmSet, TotalCount } = data?.ListAlarmsResult || {}
        return {
          tableData: AlarmSet || [],
          totalCount: TotalCount || 0
        }
      } else {
        const { IncidentSet, TotalCount } = data?.ListIncidentsResult || {}
        return {
          tableData: IncidentSet || [],
          totalCount: TotalCount || 0
        }
      }
    }
  )

  useEffect(() => {
    dataSource && run()
  }, [dataSource])

  const tableScheme = useMemo(() => {
    if (network === 'ib') {
      return {
        Name: {
          title: _$('告警名称'),
          width: 200
        },
        Timestamp: {
          title: _$('告警时间'),
          width: 120
        },
        Description: {
          title: _$('告警描述'),
          width: 150
        },
        Severity: {
          title: _$('严重等级'),
          multiple: true,
          width: 100,
          group: SeverityGroup
        },
        ObjectPath: {
          title: _$('告警源'),
          width: 200
        },
        Reason: {
          title: _$('告警原因'),
          width: 400
        }
      }
    } else if (network === 'rock') {
      return {
        Name: {
          title: _$('告警名称'),
          width: 200
        },
        OccurTime: {
          title: _$('告警时间'),
          width: 120
        },
        Priority: {
          title: _$('告警优先级'),
          width: 100,
          template: ({ Priority }) => {
            switch (Priority) {
              case 'high':
                return _$('高')
              case 'middle':
                return _$('中')
              case 'low':
                return _$('低')
              default:
                return Priority
            }
          }
        },
        Category: {
          title: _$('告警类别'),
          width: 200
        },
        Detail: {
          title: _$('告警描述'),
          width: 400
        }
      }
    }
  }, [network])

  return (
    <div className={className} id={className}>
      <a
        onClick={() => {
          setVisible(true)
        }}
      >
        {_$('告警历史')}
      </a>
      <Drawer
        value={visible}
        container={() => document.getElementById(className)}
        width="85%"
        onChangeValue={show => {
          if (show) {
          } else {
            setSearch('')
            setTableGroup(undefined)
            setVisible(show)
          }
        }}
        title={_$('告警历史')}
      >
        <>
          <div className="header">
            <QuickRangeDate
              format="YYYY-MM-DD HH:mm"
              optionalDateRange={30}
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              defautlValue={'近1小时'}
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              quickRange={['近1小时', '近1天', '近3天', '近1周']}
              changeValue={date => {
                const state = date[0] ? dayjs(date[0]).unix() : undefined
                const end = date[1] ? dayjs(date[1]).unix() : undefined
                setDateTime({
                  StartTime: state,
                  EndTime: end
                })
                dataSource && run({ StartTime: state, EndTime: end, PageIndex: 1 })
              }}
            />
            <MonitorSearch
              placeholder={_$('输入告警名称')}
              onChange={value => {
                run({ Query: value, PageIndex: 1 })
                setSearch(value)
              }}
            />
          </div>
          {tableScheme ? (
            <TablePage
              tableProps={{
                scheme: tableScheme,
                data: result,
                checkType: 'none',
                resizable: true,
                group: tableGroup,
                onChangeGroup: value => {
                  setTableGroup(value)
                  run({
                    PageIndex: 1,
                    Severity: value.Severity.join(',')
                  })
                }
              }}
              pageProps={{ total, ...pageState }}
              loading={loading}
              run={run}
            />
          ) : null}
        </>
      </Drawer>
    </div>
  )
}

export default styled(CloudAlarm)`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`
